/* eslint-disable camelcase */

/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
import { PrismicDocumentType } from '@lib/data/prismic';
import Prismic from 'prismic-javascript';
import { RichTextBlock } from 'prismic-reactjs';
import { reportError } from './sentry';

const REPOSITORY = 'normma';
const REF_API_URL = `https://${REPOSITORY}.prismic.io/api/v2`;
const GRAPHQL_API_URL = `https://${REPOSITORY}.prismic.io/graphql`;
const accessToken = '';

export const PrismicClient = Prismic.client(REF_API_URL, {
  accessToken,
});

export async function fetchPrismicAPI<T>(
  query: string,
  options?: { variables: Record<string, any> },
) {
  const prismicAPI = await PrismicClient.getApi();
  const res = await fetch(
    `${GRAPHQL_API_URL}?query=${query}&variables=${JSON.stringify(
      options?.variables,
    )}`,
    {
      headers: {
        'Prismic-Ref': prismicAPI.masterRef.ref,
        'Content-Type': 'application/json',
        'Accept-Language': 'en-us',
      },
    },
  );

  if (res.status !== 200) {
    const text = await res.text();
    console.log(text);

    return null;
    reportError(text);
    throw new Error('Failed to fetch API');
  }

  const json = await res.json();
  if (json.errors) {
    reportError(json.errors);
    throw new Error('Failed to fetch API');
  }
  return json.data as T;
}

export async function getAllPostsWithSlug() {
  const data = await fetchPrismicAPI<{
    allPosts: {
      edges: {
        node: {
          _meta: {
            uid: string;
          };
        };
      }[];
    };
  }>(`
    {
      allPosts(first: 99999999) {
        edges {
          node {
            _meta {
              uid
            }
          }
        }
      }
    }
  `);

  return data?.allPosts?.edges;
}

export async function getAllCategoriesWithSlug() {
  interface Data {
    allCategorys: AllCategorys;
  }

  interface AllCategorys {
    edges: Edge[];
  }

  interface Edge {
    node: Node;
  }

  interface Node {
    _meta: Meta;
  }

  interface Meta {
    uid: string;
  }

  const data = await fetchPrismicAPI<Data>(`
{
  allCategorys(first: 99999999) {
    edges {
      node {
        _meta {
          uid
        }
      }
    }
  }
}
  `);

  return data?.allCategorys.edges;
}

interface AllInsuranceterms {
  edges: Edge[];
}

interface Edge {
  node: InsuranceTermsNode;
}

export interface InsuranceTermsNode {
  title: RichTextBlock[];
  description: RichTextBlock[];
  _meta: Meta;
}

interface Meta {
  uid: string;
}

export async function getAllInsuranceTermsNodes() {
  const data = await fetchPrismicAPI<{
    allInsurance_terms: AllInsuranceterms;
  }>(`
{
  allInsurance_terms(first: 99999999) {
    edges {
      node {
        title
        description
       _meta {
        uid
       }
      }
    }
  }
}
  `);

  return data?.allInsurance_terms.edges;
}

export async function getPrismicDocumentById(id: string) {
  interface Data {
    _allDocuments: {
      edges: {
        node: {
          _meta: {
            uid: string;
            type: PrismicDocumentType;
          };
        };
      }[];
    };
  }

  const data = await fetchPrismicAPI<Data>(`
{
  _allDocuments(id:"${id}") {
    edges {
      node
      {
        _meta {
          uid
          type
        }
      }
    }
  }
}
  `);

  return data?._allDocuments?.edges?.length &&
    data?._allDocuments.edges.length > 0
    ? data?._allDocuments.edges[0].node
    : null;
}

export async function getAllInusranceCarrierPages() {
  interface Data {
    allInsurance_carriers: {
      edges: Edge2[];
    };
  }

  interface Edge2 {
    node: Node;
  }

  interface Node {
    _meta: Meta2;
  }

  interface Meta2 {
    uid: string;
  }

  const data = await fetchPrismicAPI<Data>(`
{
  allInsurance_carriers(first: 99999999) {
    edges {
      node {
        _meta {
          uid
        }
      }
    }
  }
}
  `);

  return data?.allInsurance_carriers.edges;
}
